import { Group, Tag } from '../../types';

export const getGroupTag = (group: Group): Tag | undefined => {
  if (!group) return undefined;
  return group.groupType === 'ACTIVATED_TEAM' ? group.tag : group.team?.tag;
};
